import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { getHoursFromTime, validateTime } from 'redux/helpers/reminders';
import AddAdminMemoModalComponent from 'components/AddAdminMemoModal';
import {
    SEND_TO_OPTIONS,
    sendToOptions,
    typeOptions,
} from 'components/AddAdminMemoModal/AddAdminMemoModal';
import { createAdminMemoThunk } from 'redux/actions/thunks/adminMemos';
import { useAuth0 } from '@auth0/auth0-react';

const AddAdminMemoModal = ({ closeModal, reloadAdminMemos }) => {
    const { getAccessTokenSilently, logout } = useAuth0();
    const [dateTime, setDateTime] = useState(null);
    const [hour, setHour] = useState('12:30 PM');
    const [date, setDate] = useState(new Date());
    const [message, setMessage] = useState('');
    const [users, setUsers] = useState([]);
    const [teams, setTeams] = useState([]);
    const [sendTo, setSendTo] = useState(sendToOptions[0]);
    const [type, setType] = useState(typeOptions[0]);
    const dispatch = useDispatch();

    const getIds = () => {
        switch (sendTo.id) {
            case SEND_TO_OPTIONS.send_to_selected_users:
                return users;
            case SEND_TO_OPTIONS.send_to_selected_teams:
                return teams;
            default:
                return [];
        }
    };

    const createAdminMemo = () => {
        dispatch(
            createAdminMemoThunk(
                getAccessTokenSilently,
                logout,
                {
                    admin_memo: {
                        memo_type: type.id,
                        send_to: sendTo.id,
                        send_at: dateTime.toJSON(),
                        ids: getIds(),
                        message,
                    },
                },
                reloadAdminMemos
            )
        );
        closeModal();
    };

    const setTime = (val) => {
        if (validateTime(val)) {
            setHour(val);
        }
    };

    useEffect(() => {
        const newDate = date;
        newDate.setHours(getHoursFromTime(hour));
        newDate.setMinutes(
            hour.slice(hour.indexOf(':') + 1, hour.indexOf(':') + 3)
        );
        setDateTime(newDate);
    }, [hour, date]);

    return (
      <AddAdminMemoModalComponent
            closeModal={closeModal}
            sendTo={sendTo}
            setSendTo={setSendTo}
            type={type}
            setType={setType}
            hour={hour}
            setHour={setTime}
            date={date}
            setDate={setDate}
            message={message}
            setMessage={setMessage}
            users={users}
            setUsers={setUsers}
            teams={teams}
            setTeams={setTeams}
            createAdminMemo={createAdminMemo}
        />
    );
};

AddAdminMemoModal.propTypes = {
    closeModal: PropTypes.func.isRequired,
    reloadAdminMemos: PropTypes.func,
};

AddAdminMemoModal.defaultProps = {
    reloadAdminMemos: () => {},
};

export default AddAdminMemoModal;
